import styled, {css} from 'styled-components'
import {TableBodyCellText} from '@components/ui/table-atoms/TableAtoms.tsx'
import {MenuButton} from '@ariakit/react'

export const StyledSelectCell = styled.div(
    ({theme: {spacing, palette}}) => css`
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: ${spacing * 2}px;
        width: 100%;
        padding: ${spacing * 0.5}px;

        & svg {
            fill: ${palette.orange['600']};
        }
    `
)

export const StyledStatusCell = styled(TableBodyCellText)(
    ({theme: {spacing}}) => css`
        display: flex;
        align-items: center;
        gap: ${spacing * 2}px;
        width: 100%;
    `
)

export const StyledDiseaseCell = styled.div(
    ({theme: {typography}}) => css`
        overflow: hidden;
        & > p:first-child {
            text-decoration: underline;
        }
        & > p:last-child {
            ${typography.textXs};
        }
    `
)

export const StyledDiseaseTooltip = styled.div(
    ({theme: {typography, palette, spacing}}) => css`
        ${typography.textSm};
        color: ${palette.neutral['600']};
        font-weight: 400;

        & svg {
            fill: ${palette.neutral['500']};
            width: 16px;
            height: 16px;
        }

        & span {
            display: flex;
            align-items: center;
            gap: ${spacing}px;
        }

        & > span:first-child {
            font-weight: 500;
            color: ${palette.neutral['950']};
        }
        & > span:last-child {
            font-weight: 500;
        }
    `
)

export const StyledTherapistDoctorCell = styled.div(
    ({theme: {spacing}}) => css`
        display: flex;
        align-items: center;
        gap: ${spacing * 1.5}px;
        width: 100%;
    `
)

export const StyledReportsTrigger = styled(MenuButton)(
    ({theme: {spacing}}) => css`
        display: flex;
        align-items: center;
        gap: ${spacing * 2}px;
        & > p {
            text-decoration: underline;
        }
        & > svg {
            width: 16px;
            height: 16px;
        }
    `
)
